const accessClass = {
    CLASS_LIST: { name: 'Class', path: '/class-list' },
    ADD_CLASS: { name: 'Add Class', path: '/create-class' },
    UPDATE_CLASS: { name: 'Update Class', path: '/edit-class' },
    DELETE_CLASS: { name: 'Delete Class', path: '/delete-class' },
}

export default accessClass;
